import { useSelector } from 'react-redux';
import { PrimaryEntityItem } from '../../redux/localReports/localReports.proptype';
import { selectSelectedPrimaryEntities } from '../../selectors';

export const useSelectedPrimaryEntities = (): PrimaryEntityItem[] => {
  const selectedPrimaryEntities = useSelector(selectSelectedPrimaryEntities);

  return selectedPrimaryEntities;
};
